import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Categories from './pages/Categories';
import Clients from './pages/Clients';
import CostCenters from './pages/CostCenters';
import SalesOrders from './pages/SalesOrders';
import Suppliers from './pages/Suppliers';
import Stock from './pages/Stock';
import Expenses from './pages/Expenses';
import Settings from './pages/Settings';
import Carriers from './pages/Carriers';
import PriceTables from './pages/PriceTables';
import SupplierInvoices from './pages/SupplierInvoices';
import RetroactiveQuotes from './pages/RetroactiveQuotes';
import InvoiceIssue from './pages/InvoiceIssue';

const ProtectedRoute = ({ children }) => {
  const userId = localStorage.getItem('userId');
  if (!userId) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="categorias" element={<Categories />} />
        <Route path="clientes" element={<Clients />} />
        <Route path="centro-custos" element={<CostCenters />} />
        <Route path="pedidos" element={<SalesOrders />} />
        <Route path="pedidos/:id/nota-fiscal" element={<InvoiceIssue />} />
        <Route path="orcamentos-retroativos" element={<RetroactiveQuotes />} />
        <Route path="fornecedores" element={<Suppliers />} />
        <Route path="notas-fornecedores" element={<SupplierInvoices />} />
        <Route path="transportadoras" element={<Carriers />} />
        <Route path="tabelas" element={<PriceTables />} />
        <Route path="estoque" element={<Stock />} />
        <Route path="despesas" element={<Expenses />} />
        <Route path="configuracoes" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
